import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { CONVERSATION_THREAD_RESOLVE } from '../../../utils/apollo/conversations';
import {
  IConversationThreadFieldsFragment,
  IConversationThreadResolveMutation,
  IConversationThreadResolveMutationVariables,
} from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch } from '../../../redux/hooks';
import { resolveThread } from '../../../redux/slices/conversationThreads';

const useResolveConversationThread = () => {
  const dispatch = useAppDispatch();

  const [resolveConversationMutation] = useMutation<
    IConversationThreadResolveMutation,
    IConversationThreadResolveMutationVariables
  >(CONVERSATION_THREAD_RESOLVE);

  return useCallback(
    async (thread: IConversationThreadFieldsFragment) => {
      const result = await resolveConversationMutation({
        variables: { input: { threadId: thread.id } },
      });

      if (result?.data?.conversationThreadResolve?.resolved) {
        dispatch(resolveThread(thread));
      }
    },
    [dispatch, resolveConversationMutation],
  );
};

export default useResolveConversationThread;
